import { render, staticRenderFns } from "./articleStandard.vue?vue&type=template&id=c12655c2&scoped=true&"
import script from "./articleStandard.vue?vue&type=script&lang=js&"
export * from "./articleStandard.vue?vue&type=script&lang=js&"
import style0 from "./articleStandard.vue?vue&type=style&index=0&id=c12655c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12655c2",
  null
  
)

export default component.exports